import { z } from 'zod';

/**
 * Códigos de error estándar del backend (ver docs/00-compartido/contratos-api.md §13).
 * Single source of truth compartido por backend y frontend.
 */
export const ErrorCodeSchema = z.enum([
  'invalid_input',
  'unauthenticated',
  'forbidden',
  'not_found',
  'conflict',
  'gone',
  'business_rule_violation',
  'rate_limited',
  'internal_error',
  'dependency_unavailable',
]);
export type ErrorCode = z.infer<typeof ErrorCodeSchema>;

/**
 * Forma estándar del cuerpo de error del API.
 */
export const ApiErrorBodySchema = z.object({
  error: z.object({
    code: ErrorCodeSchema,
    message: z.string(),
    details: z.unknown().optional(),
  }),
});
export type ApiErrorBody = z.infer<typeof ApiErrorBodySchema>;